import { render, staticRenderFns } from "./ModelsCard.vue?vue&type=template&id=0727dd7e&scoped=true"
import script from "./ModelsCard.vue?vue&type=script&lang=js"
export * from "./ModelsCard.vue?vue&type=script&lang=js"
import style0 from "./ModelsCard.vue?vue&type=style&index=0&id=0727dd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727dd7e",
  null
  
)

export default component.exports